// Per-domain runtime config — SINGLE SOURCE OF TRUTH for the two things that
// differ between the domains this lander is served on.
//
// ONE Vercel deployment serves BOTH swipeyconnect.com and swipeyquiz.com. CRA
// `REACT_APP_*` env vars are baked in at BUILD time, so they can't tell the two
// domains apart — instead we branch on the live hostname at runtime. Everything
// else (backend, GrowthBook, CDN, Everflow, Mixpanel token, routes, design) is
// shared and identical across both domains.
//
// Only two values differ per domain:
//   - lpSource : attribution tag sent to the backend / GTM / Mixpanel so each
//                domain's traffic can be told apart.
//   - gtmId    : the Google Tag Manager container id.
//
// The tab title is deliberately NOT here: it is one site-wide string, hardcoded
// in public/index.html.
//
// NOTE: the GTM container also has to be loaded BEFORE React boots (in
// public/index.html, which can't import this module), so the hostname→gtmId map
// is mirrored inline there. Keep the two in sync.
//
// Unknown hosts — staging, Vercel preview URLs, localhost — fall through to the
// DEFAULT (swipeyconnect) config. Staging doesn't need to differ.

const CONFIGS = {
  'swipeyquiz.com': {
    lpSource: 'swipeyquiz',
    gtmId: 'GTM-PNXR5M33',
  },
  'swipeyconnect.com': {
    lpSource: 'swipeyconnect',
    gtmId: 'GTM-N8LQSVFS',
  },
}

// Fallback for every other host (staging / preview / localhost). Mirrors the
// swipeyconnect config so non-production environments behave like today.
const DEFAULT_CONFIG = CONFIGS['swipeyconnect.com']

// Normalize: lowercase + strip a leading `www.` so www/apex resolve the same.
const getHost = () => {
  if (typeof window === 'undefined') return ''
  return (window.location.hostname || '').toLowerCase().replace(/^www\./, '')
}

export const getDomainConfig = () => CONFIGS[getHost()] || DEFAULT_CONFIG

// Attribution tag (lp_source) for the current domain.
export const getLpSource = () => getDomainConfig().lpSource

// GTM container id for the current domain.
export const getGtmId = () => getDomainConfig().gtmId
